import { gridSize } from "@/shared";
import { Grid, TextField } from "@mui/material";
import { Control, Controller } from "react-hook-form";

export type CustomTextFielReadProps<T> = {
  label: string;
  name: string;
  valueKey: keyof T; // Para mostrar (nombre)
  actualValueKey?: keyof T; // Para enviar al backend (codigo)
  isLoadingData: boolean;
  defaultValue: string | number | null | undefined;
  control: Control<any, any>;
  value?: T | null;
  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };
  disabled?: boolean;
  onChangeValue?: (value: any)=>void;
};

const CustomTextFielRead = <T,>({
  label,
  name,
  valueKey,
  actualValueKey,
  //isLoadingData,
  defaultValue,
  control,
  size = gridSize,
  disabled = false,
  value,
  onChangeValue
}: CustomTextFielReadProps<T>) => {
  return (
    <Grid item {...size}>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue ?? ''}
        render={({ field }) => {
          // Valor a mostrar (nombre)
          const displayValue = value?.[valueKey]?.toString() ?? "";
           //console.log('displayValue', displayValue)
          // Valor real que se enviará al backend (codigo)
          const actualValue = actualValueKey
            ? value?.[actualValueKey]?.toString() ?? ""
            : displayValue;
          //console.log('actualValue', actualValue)
          // Actualizar el valor del campo si es diferente
            if (field.value !== actualValue) {
              field.onChange(actualValue);
              onChangeValue?.(actualValue) /// solo se llama si está definido
            }



          return (
            <TextField
              {...field}
              fullWidth
              label={label}
              variant="outlined"
              value={displayValue} // Mostramos el nombre
              disabled={disabled}
              InputProps={{ readOnly: true }}
            />
          );
        }}
      />
    </Grid>
  );
};

export default CustomTextFielRead;